import React from "react";
import { Image } from "spectacle";
import really from "./really.jpg";

export const S35a = () => <Image src={really} />;
